<nz-modal
  [nzVisible]="visible()"
  i18n-nzTitle
  nzTitle="Select reason for status change"
  [nzFooter]="modalFooter"
  [nzClosable]="false"
  [nzMaskClosable]="false"
  nzWidth="420px"
>
  <ng-container *nzModalContent>
    <p i18n style="margin-bottom: 12px;">
      Please select the reason for this status change:
    </p>
    <nz-select
      style="width: 100%;"
      i18n-nzPlaceHolder
      nzPlaceHolder="Select a reason"
      [ngModel]="selectedKey()"
      (ngModelChange)="selectedKey.set($event)"
    >
      @for (reason of reasons; track reason.key) {
        <nz-option [nzValue]="reason.key" [nzLabel]="reason.label"></nz-option>
      }
    </nz-select>
  </ng-container>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="onCancel()">
      <span i18n>Cancel</span>
    </button>
    <button
      nz-button
      nzType="primary"
      [disabled]="!selectedKey()"
      (click)="onOk()"
    >
      <span i18n>OK</span>
    </button>
  </ng-template>
</nz-modal>
